import { supabase } from '@/lib/supabase';
import { fetchAllRows } from '@/lib/fetchAllRows';
import type { Settlement, CreateSettlementData } from '@sharecost/shared';
import { toMinorUnits, getMinorUnitsSync } from '@sharecost/shared';

export interface SettlementWithUsers extends Settlement {
  from_user?: { id: string; display_name: string; avatar_url?: string };
  to_user?: { id: string; display_name: string; avatar_url?: string };
}

export async function fetchGroupSettlements(groupId: string): Promise<SettlementWithUsers[]> {
  const data = await fetchAllRows(
    supabase
      .from('settlements')
      .select(`
        *,
        from_user:users!from_user_id(id, display_name, avatar_url),
        to_user:users!to_user_id(id, display_name, avatar_url)
      `)
      .eq('group_id', groupId)
      .eq('_deleted', false)
      .order('settlement_date', { ascending: false }),
  );

  return data as SettlementWithUsers[];
}

export async function createSettlement(
  data: CreateSettlementData,
  createdBy: string,
  settlementDate?: string,
): Promise<string> {
  const minorUnits = getMinorUnitsSync(data.currency);
  const amountMinor = toMinorUnits(data.amount, minorUnits);
  const id = crypto.randomUUID();
  const now = new Date().toISOString();

  const { error } = await supabase.from('settlements').insert({
    id,
    group_id: data.groupId,
    from_user_id: data.fromUserId,
    to_user_id: data.toUserId,
    amount_minor: amountMinor,
    currency_code: data.currency,
    description: data.note ?? 'Settlement',
    settlement_date: settlementDate ?? now,
    created_by: createdBy,
    created_at: now,
  });

  if (error) throw error;
  return id;
}
